module.exports = __webpack_public_path__ + "static/media/00_endangered_species_map_card.da9b85e0.png";